// Mock data — verified sober living / rehab / outpatient / resource listings.
// Replace with real API (SAMHSA, internal CMS) later.

export const PROGRAM_TYPES = [
    { id: "all", label: "All Programs" },
    { id: "sober-living", label: "Sober Living" },
    { id: "rehab", label: "Rehab / Inpatient" },
    { id: "outpatient", label: "Outpatient" },
    { id: "resource", label: "Community Resource" },
];

export const US_STATES = [
    "All States",
    "California",
    "Colorado",
    "Florida",
    "Georgia",
    "Illinois",
    "Massachusetts",
    "Nevada",
    "North Carolina",
    "New York",
    "Ohio",
    "Oregon",
    "Tennessee",
    "Texas",
    "Washington",
];

export const DIRECTORY_LISTINGS = [
    {
        id: 1,
        name: "Sunrise Pines Sober Living",
        type: "sober-living",
        city: "Asheville",
        state: "North Carolina",
        description:
            "Structured men's sober living nestled in the Blue Ridge foothills. Peer accountability, weekly meetings, and outdoor recovery activities.",
        tags: ["Men's Only", "NARR Certified", "12-Step Friendly"],
        beds: 14,
        verified: true,
        image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 2,
        name: "Harbor Light Women's Recovery",
        type: "sober-living",
        city: "San Diego",
        state: "California",
        description:
            "Women's supportive housing with on-site case management, trauma-informed care, and a tight-knit sisterhood atmosphere.",
        tags: ["Women's Only", "Trauma-Informed", "Case Management"],
        beds: 10,
        verified: true,
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 3,
        name: "Cedar Ridge Treatment Center",
        type: "rehab",
        city: "Bend",
        state: "Oregon",
        description:
            "30/60/90-day residential rehab with clinical care, group therapy, and family programming on 22 wooded acres.",
        tags: ["Residential", "Clinical", "Family Program"],
        beds: 42,
        verified: true,
        image: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 4,
        name: "Clearpath Outpatient Services",
        type: "outpatient",
        city: "Austin",
        state: "Texas",
        description:
            "Evening and weekend IOP programming with MAT, individual counseling, and evidence-based CBT/DBT groups.",
        tags: ["IOP", "MAT", "Evening Hours"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 5,
        name: "Anchorpoint Community Center",
        type: "resource",
        city: "Brooklyn",
        state: "New York",
        description:
            "Drop-in recovery community space. Daily SMART Recovery, AA, NA, Refuge Recovery, and Wellbriety meetings.",
        tags: ["Drop-in", "All-Pathway", "Peer Support"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 6,
        name: "Serenity House Miami",
        type: "sober-living",
        city: "Miami",
        state: "Florida",
        description:
            "Co-ed transitional housing steps from the beach. Daily check-ins, random UAs, and active alumni community.",
        tags: ["Co-ed", "Beachside", "Alumni Network"],
        beds: 22,
        verified: true,
        image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 7,
        name: "High Country Detox & Rehab",
        type: "rehab",
        city: "Denver",
        state: "Colorado",
        description:
            "Medically-supervised detox followed by seamless residential treatment. Dual-diagnosis specialists on staff.",
        tags: ["Detox", "Dual Diagnosis", "Insurance Accepted"],
        beds: 60,
        verified: true,
        image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 8,
        name: "Lakeside Recovery Alliance",
        type: "outpatient",
        city: "Chicago",
        state: "Illinois",
        description:
            "Partial hospitalization and standard outpatient with telehealth options. LGBTQ+ affirming care.",
        tags: ["PHP", "Telehealth", "LGBTQ+ Affirming"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 9,
        name: "Red Rock Sober Living",
        type: "sober-living",
        city: "Las Vegas",
        state: "Nevada",
        description:
            "Structured recovery residence with employment support, daily meditations, and house manager on site.",
        tags: ["Men's Only", "Employment Support", "Meditation"],
        beds: 12,
        verified: true,
        image: "https://images.unsplash.com/photo-1476231682828-37e571bc172f?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 10,
        name: "Open Door Peer Recovery",
        type: "resource",
        city: "Boston",
        state: "Massachusetts",
        description:
            "Certified peer recovery coaches, harm-reduction supplies, and warm handoffs to treatment providers.",
        tags: ["Peer Coaching", "Harm Reduction", "Walk-ins"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 11,
        name: "Magnolia Women's Rehab",
        type: "rehab",
        city: "Nashville",
        state: "Tennessee",
        description:
            "Holistic women's residential program. Yoga, equine therapy, trauma work, and spiritual care optional.",
        tags: ["Women's Only", "Holistic", "Trauma Care"],
        beds: 28,
        verified: true,
        image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 12,
        name: "Evergreen IOP Seattle",
        type: "outpatient",
        city: "Seattle",
        state: "Washington",
        description:
            "Evening IOP with small cohort sizes. Combines evidence-based care with mindfulness and community.",
        tags: ["Small Cohorts", "Mindfulness", "Evening IOP"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 13,
        name: "Peach State Sober Living",
        type: "sober-living",
        city: "Atlanta",
        state: "Georgia",
        description:
            "Long-term recovery residence for young adults. Career mentoring, GED/college support, and volunteer program.",
        tags: ["Young Adults", "Career Mentoring", "Long-Term"],
        beds: 18,
        verified: true,
        image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 14,
        name: "Buckeye Recovery Collective",
        type: "resource",
        city: "Columbus",
        state: "Ohio",
        description:
            "Recovery community center with free meetings, family support groups, and reentry services for justice-involved.",
        tags: ["Reentry", "Family Support", "All Pathways"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 15,
        name: "Pacific Coast Residential",
        type: "rehab",
        city: "Malibu",
        state: "California",
        description:
            "Upscale ocean-view treatment with concierge clinical team, private rooms, and executive program.",
        tags: ["Executive", "Private Rooms", "Ocean View"],
        beds: 24,
        verified: true,
        image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=80",
    },
    {
        id: 16,
        name: "Daybreak Outpatient Clinic",
        type: "outpatient",
        city: "Portland",
        state: "Oregon",
        description:
            "Sliding-scale outpatient counseling, MAT, and co-occurring mental health services. Walk-ins welcome.",
        tags: ["Sliding Scale", "MAT", "Walk-ins"],
        beds: null,
        verified: true,
        image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80",
    },
];

export const getTypeLabel = (id) =>
    PROGRAM_TYPES.find((t) => t.id === id)?.label || "Program";
